import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import axios from "axios";

interface LoginRequest {
    c_code: string;
    c_company_number: string;
}

interface LoginResponse {
    data: {
        accessToken: string;
        c_code: string;
        c_company_number: string;
        c_company: string;
        c_director: string;
        c_phone: string;
        c_post: string;
        c_addr1: string;
        c_addr2: string;
        c_tel: string;
        c_rpost: string;
        c_raddr1: string;
        c_raddr2: string;
        c_rtel: string;
        c_sepost: string;
        c_seaddr1: string;
        c_seaddr2: string;
        c_setel: string;
        c_no_yn: string;
        c_month_yn: string;
        c_branch: string;
        c_req_dept: string;
        c_branch2: string;
        c_rbranch: string;
        c_sebranch: string;
        c_bef_print: string;
        c_ex_item1?: string;
        c_ex_item2?: string;
        c_ex_item3?: string;
        c_ex_item4?: string;
        c_ex_item5?: string;
    };
}

export const usePostLogin = (successCallback?: () => void): UseMutationResult<LoginResponse, Error, LoginRequest, unknown> => {
    const setAuth = useMorningAuthStore(state => state.setAuth);

    return useMutation<LoginResponse, Error, LoginRequest>({
        mutationFn: async ({ c_code, c_company_number }: LoginRequest) => {
            const response = await axios.post(enum_api_uri.login, {
                c_code,
                c_company_number,
            });
            return response.data;
        },
        onSuccess: data => {
            const info = data.data;

            setAuth({
                accessToken: info.accessToken,
                c_code: info.c_code,
                c_company_number: info.c_company_number,
                c_company: info.c_company,
                c_director: info.c_director,
                c_phone: info.c_phone,
                c_post: info.c_post,
                c_addr1: info.c_addr1,
                c_addr2: info.c_addr2,
                c_tel: info.c_tel,
                c_rpost: info.c_rpost,
                c_raddr1: info.c_raddr1,
                c_raddr2: info.c_raddr2,
                c_rtel: info.c_rtel,
                c_sepost: info.c_sepost,
                c_seaddr1: info.c_seaddr1,
                c_seaddr2: info.c_seaddr2,
                c_setel: info.c_setel,
                c_no_yn: info.c_no_yn,
                c_month_yn: info.c_month_yn,
                c_branch: info.c_branch,
                c_req_dept: info.c_req_dept,
                c_branch2: info.c_branch2,
                c_rbranch: info.c_rbranch,
                c_sebranch: info.c_sebranch,
                c_bef_print: info.c_bef_print,
                c_ex_item1: info.c_ex_item1,
                c_ex_item2: info.c_ex_item2,
                c_ex_item3: info.c_ex_item3,
                c_ex_item4: info.c_ex_item4,
                c_ex_item5: info.c_ex_item5,
            });

            successCallback?.();
        },
    });
};
